var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"flex-container"},[_c('div',{staticClass:"dashboard-error-text"},[_c('div',{staticClass:"not-found"},[_c('img',{staticClass:"not-found__image notfound-image",attrs:{"src":require("@/assets/svg/element-404.svg")}}),_c('h2',[_vm._v(" "+_vm._s(_vm.$t('BrowserWarning.DashboardNotFound'))+" ")])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }